module.exports = __webpack_public_path__ + "img/82.20e955fe.jpg";